import { render, staticRenderFns } from "./product-detail-mobile-loader.vue?vue&type=template&id=3d68df80&scoped=true"
import script from "./product-detail-mobile-loader.vue?vue&type=script&lang=js"
export * from "./product-detail-mobile-loader.vue?vue&type=script&lang=js"
import style0 from "./product-detail-mobile-loader.vue?vue&type=style&index=0&id=3d68df80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d68df80",
  null
  
)

export default component.exports